import APIService from './api'

import {
  EXHIBITOR, EXHIBITION, EXHIBITED_WORK,
  getFiltersComputed
} from './filters'

export async function exportCSV (type, query) {
  let { order, direction } = query
  let jsonFilters = query.filters ? JSON.parse(query.filters) : null
  if (jsonFilters) {
    jsonFilters = jsonFilters.map(s => {
      if (s.hasOwnProperty(0)) {
        s.property = s[0]
        delete s[0]
      }
      if (s.hasOwnProperty(1)) {
        s.matchType = s[1]
        delete s[1]
      }
      if (s.hasOwnProperty(2)) {
        s.value = s[2]
        delete s[2]
      }
      return s
    })
  }
  let filters = getFiltersComputed(
    type,
    [],
    { ...query, jsonFilters }
  )
  let results = []
  const fieldsExcludedInExport = [
    // exhibition
    'search',
    'id',
    'id_city',
    'id_exhibition_group_type',
    'public',
    'nb_exhibition_catalog',
    // exhibitor
    'id_exhibition_section',
    'id_user',
    'id_birth_date', 'day_b', 'month_b',
    'id_death_date', 'day_d', 'month_d',
    'id_birth_address', // 'road_num_b', 'road_b', 'floor_b', 'locality_b', 'complement_b', 'city_b', 'state_b',
    'id_death_address', // 'road_num_d', 'road_d', 'floor_d', 'locality_d', 'complement_d', 'city_d', 'state_d',
    'id_catalog', 'id_exhibition',
    // exhibited work
    'id_exhibitor', 'id_has_exhibited_in',
    'id_start_conception_date', 'day_c1', 'month_c1',
    'id_end_conception_date', 'day_c2', 'month_c2',
    'id_address_c',
    'id_address_o'
  ]

  let fileContent = ''
  switch (type) {
    case EXHIBITOR:
      await APIService.searchExhibitor({
        filters,
        satisfy: 'all',
        order: {
          column: order || 'begin_date',
          direction: direction || 'ASC'
        }
      }).then(json => {
        results = json.visu_exhibitor
      }).catch((err) => {
        console.error(err)
      })
      break
    case EXHIBITION:
      await APIService.searchExhibitionSectionCSV({
        filters,
        satisfy: 'all',
        order: {
          column: order || 'begin_year',
          direction: direction || 'ASC'
        }
      }).then(json => {
        results = json.visu_csv_sections
      }).catch((err) => {
        console.error(err)
      })
      break
    case EXHIBITED_WORK:
//      fileContent += 'Note: the information is organized in hierarchical order: concerning the works, then their exhibitors, then the exhibitions where the works are presented.\n'
        // get all results
      await APIService.searchExhibitedWorkCSV({
        filters,
        satisfy: 'all',
        order: {
          column: 'begin_year_hide',
          direction: 'ASC'
        }
      }).then(json => {
        results = json.visu_csv_exhibited_work
      }).catch((err) => {
        console.error(err)
      })
      break
  }

//  let today = new Date()
//  fileContent += 'Thank you for quoting the Artl@s Project: BasArt, a Global Database of Exhibition Catalogues, Prof. Dr. Béatrice Joyeux-Prunel, ed., and the contributors to the database. https://artlas.huma-num.fr/map/;' + today.toLocaleDateString() + '\n'
  // headers
  const columnsToKeep = []
  if (results.columns) {
    results.columns.forEach((column, index) => {
      if (!column.endsWith('_lower') && !column.endsWith('_hide') && fieldsExcludedInExport.indexOf(column) === -1) {
        // fileContent += this.$t(`pages.results.${k}`) + ';'
        fileContent += column + ';'
        columnsToKeep.push(index)
      }
    })
  } else {
    fileContent += '\nNo exhibited work'
  }
  fileContent += '\n'

  if (results.records) {
    if (results.records.length > 0) {
      // data
      results.records.forEach(r => {
        columnsToKeep.forEach(k => {
          let value = r[k] || ''
          if (value && typeof value !== 'number') {
            value = value.replace(/"/g, '""')
          }
          fileContent += `"${value}";`
        })
        fileContent += `\n`
      })
    }
  }
  var now = new Date()
  var y = '' + now.getFullYear()
  var m = '' + (now.getMonth() + 1)
  if (m.length < 2) {
    m = '0' + m
  }
  var d = '' + now.getDate()
  if (d.length < 2) {
    d = '0' + d
  }
  var nowStr = y + m + d
  var h = '' + now.getHours()
  if (h.length < 2) {
    h = '0' + h
  }
  m = now.getMinutes()
  if (m.length < 2) {
    m = '0' + m
  }
  nowStr = nowStr + h + m
  let filename = 'BasArt_export_' + type + 's_' + nowStr + '.csv'
  var blob = new Blob([fileContent], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    var link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/export.js